import { EstimatedRange } from 'modules/salaries/types/EstimatedRange';
import { SALARIES_API_ENDPOINT_ROOT } from 'modules/salaries/utils/constants/salariesApiEndpointRoot';
import { BackgroundTask, waitTaskCompleted } from 'utils/asyncBackendTask';
import { postJson } from 'utils/http/postJson';

export async function salariesUpdateCareerPathSynonyms({
  selectedSynonymId,
  currentSynonymIds,
  city,
  stateCode,
  yearsOfExperience,
  synonymIdToAdd,
}: {
  selectedSynonymId: string;
  currentSynonymIds: string[];
  city?: string;
  stateCode?: string;
  yearsOfExperience?: number;
  useMock?: boolean;
  synonymIdToAdd?: string;
}): Promise<EstimatedRange[]> {
  const { task } = await postJson<{
    task: BackgroundTask<{ careerPath: EstimatedRange[] }>;
  }>(`${SALARIES_API_ENDPOINT_ROOT}/calculator/career-path/update`, {
    selectedSynonymId,
    currentSynonymIds,
    city,
    stateCode,
    yearsOfExperience,
    synonymIdToAdd,
  });

  const { careerPath } = await waitTaskCompleted(task);
  return careerPath;
}
